<ng-template #loading>
    <div class="m-loader m-loader--brand pb-5 text-center"></div>
</ng-template>

<div class="m-portlet mb-2" [ngClass]="{ 'border-danger border': noteItemForm?.invalid }">
    <div [data]="formValue" [isFormDirty]="noteItemForm?.dirty" (onSave)="onSave()" trt-wid-m-note-i-header class="m-portlet__head"></div>
    <div *ngIf="formValue.isDetailsOpend" class="m-portlet__body">
        <form *ngIf="noteItemForm; else loading" [formGroup]="noteItemForm" novalidate>
            <div class="row">
                <div class="col-lg-3 d-flex">
                    <i ngbTooltip="Datum dogodka" container="body" class="la la-calendar m--font-inverse-light mt-2 mr-2"></i>
                    <input
                        [options]="dueDatePickerSettings"
                        (selected)="selectedDate($event)"
                        placeholder="Kratek naslov zdravljenja"
                        formControlName="eventDate"
                        daterangepicker
                        class="form-control m-input"
                    />
                </div>
                <div class="col-lg-9 d-flex">
                    <i ngbTooltip="Naslov" container="body" class="la la-i-cursor m--font-inverse-light mt-2 mr-2"></i>
                    <input (keyup)="setFormNotChecked()" placeholder="Naziv dogodka" formControlName="title" class="form-control m-input" />
                </div>
            </div>
            <!-- m-row--no-padding  -->
            <div class="row pt-2">
                <div class="col-8">
                    <div class="d-flex h-100">
                        <i ngbTooltip="Opis" container="body" class="la la-file-text m--font-inverse-light mt-2 mr-2"></i>
                        <textarea (keyup)="setFormNotChecked()" rows="3" formControlName="content" class="form-control m-input"></textarea>
                    </div>
                </div>
                <div class="col-4">
                    <div class="d-flex h-100">
                        <i ngbTooltip="Dokumenti" container="body" class="la la-file m--font-inverse-light mt-2 mr-2"></i>

                        <ng-container *ngIf="formValue.id; else notcreated">
                            <trt-wid-m-documents [noteId]="formValue.id" [setData]="formValue?.documents" class="w-100 h-100"></trt-wid-m-documents>
                        </ng-container>
                        <ng-template #notcreated>
                            <h4>Pred dodajanjem dokumentov je potrebno shraniti dogodek</h4>
                        </ng-template>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
